module.exports = __webpack_public_path__ + "img/new_index_customers5.67fa601a.png";